import lazySizes from 'lazysizes';
//import './boxheight';

document.addEventListener('DOMContentLoaded', function() {
    /// lazysizes config
    window.lazySizesConfig = window.lazySizesConfig || {};
    lazySizesConfig.loadMode = 1;
    lazySizesConfig.preloadAfterLoad = true;
    lazySizesConfig.expand = 1500;
    lazySizesConfig.ricTimeout = 0;
    lazySizes.init();
});

